








































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Dictionary } from "vuex";
import ApiFactory from "@/api/ApiFactory";
import { UserStore, LoadingSpinnerService } from "@/store";

@Component
export default class FundMixChart extends Vue {
  @Prop() policyId: number | undefined;
  @Prop() contactId: number | undefined;
  @Prop() id: number | undefined;

  private fundMixData: Dictionary<number> | null = null;
  private fundMixOptions = {
    // tooltip: {
    //   trigger: "none"
    // },
    chartArea: {
      left: 0,
      right: 0
    },
    sliceVisibilityThreshold: 0,
    pieStartAngle: 90
  };
  private fundMixColors: string[] = [
    "#418CF0",
    "#FCB441",
    "#E0400A",
    "#056492",
    "#BFBFBF",
    "#1A3B69"
  ];

  async mounted() {
    await this.getFundMix();
  }

  private async getFundMix() {
    if (!this.id) throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();

    this.fundMixData = await api.funds_GetFundMix(
      this.contactId || UserStore.profileId,
      this.policyId || 0,
      this.id
    );
  }
}
